import * as React from "react";
import "./profilesHeaderViewStyles.css";
import "../../../../styles/sprite.css";
import { useFocusable } from "../../../../utils/Helpers";
export var ProfilesHeaderView = function (_a) {
    var t = _a.t, userName = _a.userName, userMail = _a.userMail, handleLogOut = _a.handleLogOut;
    var isSilkUser = userMail.indexOf("@silk-tv.internal") > -1;
    var ref = useFocusable({
        group: "logout",
        index: 0,
        onKeyDown: handleLogOut,
    });
    return (React.createElement("div", { className: "header-container" },
        React.createElement("div", { className: "caveaplus-logo" }),
        React.createElement("div", { className: "header-content" },
            React.createElement("p", { className: "sign-in-info" },
                t("profile.signed_in_as"),
                " ",
                React.createElement("span", null,
                    userName,
                    " ",
                    !isSilkUser && React.createElement("span", null,
                        ", ",
                        userMail))),
            React.createElement("button", { id: "log-out-btn", tabIndex: 0, ref: ref, className: "logout-btn" },
                React.createElement("div", { className: "log-out-icon" }),
                React.createElement("span", null, t("header.logout"))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/profiles/header/ProfilesHeaderView.tsx
// module id = 154
// module chunks = 1